/**
 * Hosts configured in images.remotePatterns (next.config.mjs).
 * KEEP IN SYNC with next.config.mjs — the config cannot import runtime utils.
 *
 * Config answers "what the optimizer MAY fetch";
 * this answers "should THIS url go through the optimizer".
 *
 * Precondition: expects the output of normalizeImageUrl()
 * (absolute http(s) or site-relative paths).
 *
 * Garbage / non-URL strings are treated as optimizable (status quo):
 * next/image fails, GameCard onError shows the fallback. That costs one
 * optimizer round-trip; keeping them raw would change behavior.
 */
const OPTIMIZED_IMAGE_HOSTS = new Set([
  "cdn.hub88.io",
  "files.onetouch.io",
  "secrzaapg5nnoosz.public.blob.vercel-storage.com"
])

// AI game cards are rendered at display size as WebP; another optimizer pass only adds cost.
const PRESIZED_AI_CARD = /^\/powerbet\/casino\/games\/ai\/.+\.webp$/

export function isOptimizableImageUrl(url: string): boolean {
  const candidate = url.toLowerCase()

  if (!candidate.startsWith("http://") && !candidate.startsWith("https://")) {
    return true
  }

  try {
    if (!candidate.startsWith("https://")) {
      return false
    }

    const parsed = new URL(candidate)
    if (PRESIZED_AI_CARD.test(parsed.pathname)) {
      return false
    }

    return OPTIMIZED_IMAGE_HOSTS.has(parsed.hostname)
  } catch {
    return false
  }
}
